import React from 'react';
import { Link } from 'react-router-dom';
import { merchantProfile } from '../../data/gtbankUatData';
import Div from '../Div';
import { UatNote, UatPageShell } from './UatDocumentationPage';

function VisaBadge() {
  return (
    <Div
      style={{
        width: 180,
        height: 110,
        borderRadius: 18,
        background: 'linear-gradient(135deg, #ffffff, #e8f2ff)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0 16px 30px rgba(0,0,0,0.18)',
      }}
    >
      <span style={{ color: '#1434cb', fontSize: 38, fontWeight: 800, letterSpacing: 3 }}>
        VISA
      </span>
    </Div>
  );
}

function MastercardBadge() {
  return (
    <Div
      style={{
        width: 180,
        height: 110,
        borderRadius: 18,
        background: 'linear-gradient(135deg, #ffffff, #fff2eb)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0 16px 30px rgba(0,0,0,0.18)',
        gap: 10,
      }}
    >
      <Div
        style={{
          width: 44,
          height: 44,
          background: '#eb001b',
          borderRadius: '50%',
          opacity: 0.92,
        }}
      />
      <Div
        style={{
          width: 44,
          height: 44,
          background: '#f79e1b',
          borderRadius: '50%',
          marginLeft: -18,
          opacity: 0.92,
        }}
      />
      <span style={{ color: '#222', fontSize: 20, fontWeight: 700 }}>Mastercard</span>
    </Div>
  );
}

export default function CheckoutPage() {
  return (
    <UatPageShell
      title="Payment"
      breadcrumb="Payment"
      heading="Secure Card Payments Accepted"
      subtitle="MPGS Hosted Checkout preparation for GTBank UAT"
    >
      <p className="cs-m0" style={{ fontSize: 18, marginBottom: 6 }}>
        <strong>{merchantProfile.name}</strong>
      </p>
      <p className="cs-m0" style={{ opacity: 0.82, lineHeight: 1.8 }}>
        Secure card payments accepted
      </p>
      <Div
        style={{
          marginTop: 30,
          display: 'flex',
          gap: 22,
          flexWrap: 'wrap',
          justifyContent: 'center',
        }}
      >
        <VisaBadge />
        <MastercardBadge />
      </Div>
      <UatNote>{merchantProfile.statement}</UatNote>
      <Div style={{ marginTop: 28, display: 'flex', justifyContent: 'center' }}>
        <Link to="/checkout/confirm" className="cs-btn cs-style1" style={{ display: 'inline-flex' }}>
          <span>Continue to Checkout Confirmation</span>
        </Link>
      </Div>
    </UatPageShell>
  );
}
